import BaseModule from "~/vuex/modules/base-module";
import Customers from "./customers";

let MasSettings = {...BaseModule};

MasSettings.state = function () {
    let state = BaseModule.state();

    state.endpoints['all'] = '/api/mas/settings';
    return state;
};

MasSettings.actions.updateOption = async function ({ commit, dispatch, getters, state, rootGetters }, data = {}) {
    state.endpoints['update'] = '/api/mas/settings/update';
    return dispatch('update2', {
        data: data,
    });
};

export default MasSettings;
